/* eslint-disable react/jsx-props-no-spreading */
import { Button } from "@material-ui/core";
import { useFormikContext } from "formik";
import React from "react";

const SubmitButton = ({ children, disabled, defaultEnabled, ...rest }) => {
  const { submitForm, dirty, isValid, isSubmitting } = useFormikContext();
  return (
    <Button
      {...rest}
      onClick={submitForm}
      disabled={disabled || isSubmitting || (!dirty && !defaultEnabled) || !isValid}
    >
      {children}
    </Button>
  );
};

export default SubmitButton;
